import styled from 'styled-components';

interface ContainerProps {
  isBig: boolean;
}

export const FloatingContainer = styled.div<ContainerProps>`
  position: absolute;
  bottom: 25px;
  right: 30px;
  
  width: ${(p) => (p.isBig ? '50%' : '15%')};
  height: ${(p) => (p.isBig ? '70%' : '45%')};

  overflow: scroll;
`;
